import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env/environment';

@Pipe({
  name: 'contractHref',
  standalone: false,
})
export class ContractHrefPipe implements PipeTransform {
  transform(contractMasterId: number): string {
    return `${environment.ui.contractsURL}contracts/detail?id=${contractMasterId}`;
  }
}
